import { isBefore } from 'date-fns/fp';
import type { ErrorDetails } from '#api/errors.ts';

type Props = {
  sessionStart: Date | null;
  sessionEnd: Date | null;
  errors: ErrorDetails[];
};

/**
 * Calculates whether the stream has been started, ended, was disconnected, or none of those (init).
 * This is a bit different from the `status` that is reported by the worker, because it looks at the
 * start and end times of the session to distinguish between init and ended.
 */
export function calculateStreamState({ sessionStart, sessionEnd, errors }: Props) {
  const lostConnection = errors.some((e) => e.code === 'ERR_DNCLIENT_DISCONNECTED');

  if (!sessionStart) return { state: 'init' as const, at: null };

  // No end, or end is before the start (restarted)
  if (!sessionEnd || isBefore(sessionStart)(sessionEnd)) return { state: 'started' as const, at: sessionStart };

  if (lostConnection) return { state: 'disconnected' as const, at: sessionEnd };

  return { state: 'ended' as const, at: sessionEnd };
}
